import { CornersOutIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Expand = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <CornersOutIcon {...rest} size={Sizes[size]} color={fill}>
      <path
        d="M3 10H1v5h5v-2H3v-3zM1 6h2V3h3V1H1v5zm12 7h-3v2h5v-5h-2v3zM10 1v2h3v3h2V1h-5z"
        fillRule="nonzero"
      />
    </CornersOutIcon>
  );
};

Expand.displayName = 'Expand';
